import React from 'react';
import { useSelector } from 'react-redux';
import Bullet from 'components/prism/bullet';
import { translateCourse } from 'helpers/translations';

export const Course = ({ course, padBottom }) => {
    const { user } = useSelector(state => state.user);

    course = translateCourse(user.language_Code, course);

    return (
        <a
            href={course.url || '#'}
            data-testid="course-item"
            className={`prism-content-box anchor-top ${padBottom ? 'mb10' : ''}`}
        >
            <div className="prism-banner-float flex flex-center">
                <Bullet type="course" />
            </div>
            <div className="prism-banner">
                <img src="/dist/img/defaults/course-default.jpg" />
            </div>
            <div className="prism-content flex flex-column">
                <div className="prism-progress">
                    <div className="prism-progress-bar">
                        <div style={{ width: `${course?.progress}%` }} />
                    </div>
                    <div>{course?.progress}%</div>
                </div>
                <h3>{course?.name}</h3>
                <div className="flex-grow">{course?.description && <p className="truncate-4">{course.description}</p>}</div>
                <div>
                    <button className="btn btn-primary">{course?.progress ? 'Resume' : 'Start'}</button>
                </div>
            </div>
        </a>
    );
};

export default Course;
